module.exports = require("./id-ID");